import React, { Fragment, useState, useEffect } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback, Container } from 'reactstrap';
import FormAddAdvancePayment from './FormAddAdvancePayment';
import Spinner from 'react-bootstrap/Spinner';
import moment from 'moment';
import { formatNumber } from '../../Utils/Money';
import DataReactTableAdvance from './DataReactTableAdvance';


const AdvancePayment = () => {
    const [advancesPayment, setAdvancesPayment] = useState(null);
    const [loadTable, setLoadTable] = useState(null);
    const [onEdit, setOnEdit] = useState(false);
    const [advanceToEdit, setAdvanceToEdit] = useState(null);


    useEffect(() => {
        getAdvancePayments();
    }, [])

    const getAdvancePayments = async () => {
        setLoadTable(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'anticipo/listar', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                console.log("DATOSGET", data);
                if (data.length > 0) {
                    setAdvancesPayment(data);
                } else {
                    setAdvancesPayment(null)
                }
                setLoadTable(false);
            })
            .catch((error) => {
                console.log(error)
            })
    };


    const reactTableDataAdvancedPayment = {
        tableHeaderData: [{
            Header: 'FECHA',
            accessor: 'fecha_creacion',
            //disableGlobalFilter: true,
            width: 65,
            Cell: row => (
                <label>{row.value != null && row.value != undefined ? moment(row.value).format("YYYY/MM/DD") : null}</label>
            )
        },
        {
            Header: 'CLIENTE',
            accessor: 'nombre',
        },
        {
            Header: 'VALOR',
            accessor: 'valor',
            Cell: row => (
                <label>{row.value !== null && row.value !== undefined ? "$" + formatNumber(row.value) : ''}</label>
            ),
        },
        {
            Header: 'FORMA DE PAGO',
            Cell: row => (
                <label>{row.row.original.metodo_pago.metodo_pago.medio}</label>
            ),
        },
        {
            Header: 'CONCEPTO',
            accessor: 'concepto',
        },
        ],
        tableRowsData: advancesPayment
    };

    const LoadInfo = () => {
        return (<DataReactTableAdvance
            reactTableData={reactTableDataAdvancedPayment}
            refresh={getAdvancePayments}
            setOnEdit={setOnEdit}
            setAdvanceToEdit={setAdvanceToEdit}
        />)
    }

    return (
        <Fragment>
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 style={{ marginBottom: 15 }}>Anticipos</h3>
                    </Col>
                </Row>
                <Card>
                    <CardBody>
                        <Row>
                            <FormAddAdvancePayment onEdit={onEdit} setOnEdit={setOnEdit} setAdvanceToEdit={setAdvanceToEdit} advanceToEdit={advanceToEdit} getAdvancePayments={getAdvancePayments} />
                        </Row>
                        {loadTable ?
                            <div className="text-center">
                                <Spinner animation="border" style={{ color: '#4ce1b6' }} />
                            </div>
                            :
                            advancesPayment &&
                                advancesPayment.length !== 0 ?
                                <Row>
                                    <LoadInfo />
                                </Row>
                                :
                                <div className="info-empty-profile">
                                    <h5>No se ha generado aún ningun anticipo</h5>
                                </div>
                        }
                    </CardBody>
                </Card>

            </Container>
        </Fragment>
    )
}

export default AdvancePayment